import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#6b8e76",
    },
  },
  typography: {
    fontFamily: "Poppins, san-serif",
  },
  components: {
    MuiButton: {
      variants: [
        {
          // Target the 'text' variant of the Button
          props: { variant: "text" },
          style: {
            border: "none !important", // Remove the border for text variant
          },
        },
      ],
      styleOverrides: {
        root: {
          fontWeight: 500,
          borderRadius: "8px",
          textTransform: "capitalize",
          padding: "14px 24px",
          fontSize: "16px",
          lineHeight: "20px",
          "&:disabled": {
            backgroundColor: "#d6d5cb !important",
            borderColor: "#d6d5cb !important",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          background: "#fff",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          borderWidth: "3px",
          "& .MuiOutlinedInput-root": {
            fontFamily: "Poppins, san-serif",
            borderRadius: "8px",
            width: "100%",
            background: "#fff",
            "input, textarea": {
              border: "none !important",
            },
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          border: "none !important",
          textTransform: "capitalize",
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            backgroundColor: "transparent !important",
          },
          "&:hover": {
            backgroundColor: "transparent !important",
          },
          "&.Mui-selected": {
            backgroundColor: "transparent",
            color: "#6b8e76",
            fontWeight: "600",
          },
        },
      },
    },
  },
});

export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75vw",
  maxWidth: "1200px",
  minWidth: "600px",
  maxHeight: "90vh",
  background: "#F5F2E7",
  boxShadow: 24,
  p: 5,
  outline: "none",
  borderRadius: "1rem",
  overflowY: "scroll",
  scrollbarWidth: "thin", // Firefox
  "&::-webkit-scrollbar": {
    width: "6px", // 👈 for vertical scroll
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#bdbdbd",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f0f0f0",
  },
};
